import React from 'react';
import { useState } from 'react';
const classNames = require('classnames');

class AssessmentAnswer extends React.Component {

    constructor(props) {
        super(props);        
        this.state = {
            feedbacktext : '',
            checkedIds: [],
        }        
    }

   


    render() {
        // console.log(this.props);   
        let multichoice = [];  
        localStorage.setItem('multichoiceselected','false');
        if(localStorage.getItem('typecheck') != null){
            localStorage.removeItem('typecheck');
        }
        const {id, val='', selected=false,type,feedbacktext,index,feedbackmultichoice} = this.props;   
        let liClass = classNames({
            'assessment-answer-selected': selected,
            'assessment-answer': true
        });

        let multichoicestyle = classNames({
            display: 'flex',
            alignItems: 'center'
        });

        if(this.props.type == 'multichoice'){
            localStorage.setItem('typecheck',this.props.type);
        }

        if(this.props.type == 'text'){
            localStorage.setItem('typecheck',this.props.type);
        }

        const  handleChangeName = (e) => {     
            // console.log(e.target.value);            
            // this.props.val = e.target.value;           
            // this.props.feecbacktext = e.target.value;
            // console.log(this.state.feedbacktext);
            // this.setState({
            //     feedbacktext:e.target.value
            // });
            //  this.state.feedbacktext = e.target.value;
            // this.props.feedbacktext = e.target.value;
            
            localStorage.setItem('feedbacktext',e.target.value);
            // localStorage.setItem('typecheck',this.props.type);    
            this.props.onClick(id);     
        };

        const handleChecked = (event) => {
            // console.log(id);
            // console.log(event.target.checked);    
            // console.log(event.target.value); 
            // console.log(this.props.index);
    
            // if(event.target.checked){
            //     setPeopleInfo([
            //         ...peopleInfo
            //       ]);
            // }else{
            //     setPeopleInfo(
            //         peopleInfo.filter((id) => id !== event.target.value),
            //       );                
            // }       
            // const isChecked = event.target.checked; 
            // if (isChecked) {
            //     // Add the ID to the checkedIds array
            //     this.setState(prevState => ({
            //         checkedIds: [...prevState.checkedIds, event.target.value],
            //     }));
            // } else {
            //     // Remove the ID from the checkedIds array
            //     this.setState(prevState => ({
            //         checkedIds: prevState.checkedIds.filter(prevId => prevId !== event.target.value),
            //     }));
            // }
    
            // console.log(this.state.checkedIds);                
            
            if (event.target.checked) {       
                multichoice = JSON.parse(localStorage.getItem('feedbackmultichoice'));  
                // console.log(multichoice);
                if(multichoice == null){
                    multichoice = [];
                }
                multichoice = multichoice.concat([event.target.value]);
                localStorage.setItem('feedbackmultichoice',JSON.stringify(multichoice));                                
            } else {
                multichoice = JSON.parse(localStorage.getItem('feedbackmultichoice')); 
                const index = multichoice.indexOf(event.target.value);
                if (index === -1) {
                    console.error("checkbox was unchecked but had not been registered as checked before");
                } else {
                    multichoice.splice(index, 1);
                    localStorage.setItem("feedbackmultichoice",JSON.stringify(multichoice));
                }
                
            }      
            // console.log(multichoice);     
            if(multichoice.length > 0){
                localStorage.setItem('multichoiceselected','true');
            }else{
                localStorage.setItem('multichoiceselected','false');
            }
        };

        // eslint-disable-next-line no-undef


        // multichoice = () =>{
        //     multichocefeedback.push(id);
        // }

        return( 
            <div>
            {
                (this.props.type != 'text' && this.props.type != 'multichoice') && 
                <div>                    
                    <li key={id} type="A" onClick={() => this.props.onClick(id)} className={liClass}
                        dangerouslySetInnerHTML={{__html:val}} />
                    </div>
            }   
            {
                    (this.props.type == 'text') &&  
                    <div>                   
                        <textarea key={val} name="w3review" rows="10" cols="65" style={{resize:"none"}} onKeyUp={handleChangeName}/>
                    </div>
            }  

            {
                    (this.props.type == 'multichoice') &&  
                    <div style={{display:'flex',alignItems:'center'}}>                                                                                          

                        <input type="checkbox" style={{marginRight:'20px',height:'20px',width:'20px'}} value={id} key={id} onChange={(e)=> handleChecked(e)} onClick={() => this.props.onClick(id)} index={index}/>                        

                        <li style={{marginLeft:'20px'}} key={id} type="A"/>

                        <span style={{marginLeft:'15px'}} dangerouslySetInnerHTML={{__html:val}}></span>
                    </div>
            } 
            </div>    
        );
    }
}

export default AssessmentAnswer;



// WEBPACK FOOTER //
// ./src/js/components/app/jre/elements/assessment/assessment-answer-node.js